import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeadingComponent, HeadingSpacing } from '@app/components/heading';
import { TranslateModule } from '@ngx-translate/core';
import { AaptivRoles } from '@skyfit/core-data-library';
import { MainTabComponent, NavLink } from './components/main-tab.component';

@Component({
  selector: 'app-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrl: './main-navigation.component.css',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MainTabComponent,
    HeadingComponent,
  ],
})
export class MainNavigationComponent {
  @Input() links!: Array<NavLink>;
  @Input() title!: string;
  @Input() userRoles?: AaptivRoles[];
  spacing = HeadingSpacing.LARGE;

  hasAccess(link: NavLink): boolean {
    if (!link.accessRoles) {
      return true;
    }

    if (!this.userRoles && link.accessRoles.length > 0) {
      console.warn(
        'When providing access roles within a link, userRoles must also be provided to the component.'
      );
      return false;
    }

    return link.accessRoles.some((role) => this.userRoles.includes(role));
  }
}
